function initCustomTabs(context = document) {
  const tabsWrappers = context.querySelectorAll(".custom_tabs-wrapper");
  tabsWrappers.forEach(wrapper => {
    const tabs = wrapper.querySelectorAll(".custom_tabs-nav li");
    const contents = wrapper.querySelectorAll(".custom_tab-content");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));
        tab.classList.add("active");
        contents[index].classList.add("active");
      });
    });
  });
}

function initMobileAccordions(context = document) {
  const accordions = context.querySelectorAll(".tabs_accordion-header");
  accordions.forEach(header => {
    header.addEventListener("click", () => {
      const isActive = header.classList.contains("active");
      const beforeTop = header.getBoundingClientRect().top;

      accordions.forEach(h => {
        h.classList.remove("active");
        h.nextElementSibling?.classList.remove("open");
      });

      if (!isActive) {
        header.classList.add("active");
        header.nextElementSibling?.classList.add("open");
      }

      const afterTop = header.getBoundingClientRect().top;
      const diff = afterTop - beforeTop;
      if (Math.abs(diff) > 2) {
        window.scrollBy(0, diff);
      }
    });
  });
}

// Run once when page loads
document.addEventListener("DOMContentLoaded", () => {
  initCustomTabs();
  initMobileAccordions();
});

// Run again when Shopify reloads this section
document.addEventListener("shopify:section:load", (e) => {
  initCustomTabs(e.target);
  initMobileAccordions(e.target);
});

// Also run when sections are reordered or updated in the editor
document.addEventListener("shopify:section:select", (e) => {
  initCustomTabs(e.target);
  initMobileAccordions(e.target);
});


// Watch for dynamically injected product content (e.g. quick view)
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      // If a product modal/drawer is injected
      if (
        node.querySelector?.(".custom_tabs-wrapper") ||
        node.querySelector?.(".tabs_accordion-header")
      ) {
        initCustomTabs(node);
        initMobileAccordions(node);
      }
    });
  });
});

// Start observing the entire body for new nodes
observer.observe(document.body, {
  childList: true,
  subtree: true
});
